import { FC, useEffect } from 'react'
import MainLayout from '../../components/MainLayout'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import CaseNavbar from '../../components/CaseNavbar'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import useAutoLogout from '../../hooks/useAutoLogout'
import { deselectCase } from '../../store/reports/reportsSlice'
import { AppDispatch } from '../../store'

const CasesPage: FC = () => {
  const selectedCase = useSelector(reportsSelectors.selectedReport)
  const caseIsOpening = useSelector(reportsSelectors.caseIsOpening)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()
  const autoLogout = useAutoLogout()

  useEffect(() => {
    if (caseIsOpening) {
      return
    }
    if (!selectedCase && !location.pathname.includes('/inbox')) {
      navigate('/inbox')
    }
  }, [selectedCase])

  useEffect(() => {
    if (location.pathname.includes('/inbox') && selectedCase) {
      dispatch(deselectCase({ value: undefined }))
    }
  }, [location.pathname])

  const resolveCaseNavbarShow = () => {
    if (selectedCase || location.pathname.includes('/newCase')) return <CaseNavbar />
  }

  const withBottomBorder = ['/cases/initialReport', '/cases/overview', '/cases/newCase'].includes(
    location.pathname,
  )
    ? 't-with-bottom-border'
    : ''
  return (
    <MainLayout className={withBottomBorder}>
      {resolveCaseNavbarShow()}
      <Outlet />
    </MainLayout>
  )
}

export default CasesPage
